function productIconsQtyDetect() {
	const productIconsContainer = document.querySelector(".product-icons ul");
	if (productIconsContainer) {
		const qty = productIconsContainer.childElementCount;
		productIconsContainer.style.setProperty("--icon-qty", `${qty}`);
		productIconsContainer.dataset.iconsQty = qty;
	}
}
